export const DataLayerUtils = {
  push(data) {
    window.dataLayer.push(data);
  }
}
